// extracted by mini-css-extract-plugin
module.exports = {"enterpriseClientTag":"enterpriseClientTag--MB9X3"};